import * as React from 'react';

function SvgClockWarning(props) {
  return (
    <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M10.246 1.606a.59.59 0 010-.833L10.32.71a.59.59 0 01.76.063l2.748 2.747a.59.59 0 01-.833.834l-2.748-2.748zM2.92.773L.173 3.52a.59.59 0 10.833.834l2.748-2.748A.59.59 0 002.92.773zM7 13.33A5.73 5.73 0 117 1.87a5.73 5.73 0 010 11.46zm0-8.8a.69.69 0 00-.69.689V7.61l.017.138.041.127.047.088.004.005.011.02.066.08.047.046.072.056 2.98 1.847a.69.69 0 001.055-.565l-.005-.097v-.008a.69.69 0 00-.324-.503l-2.632-1.63V5.22a.69.69 0 00-.69-.69z"
      />
    </svg>
  );
}

export default SvgClockWarning;
